/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'
import { LazyMotion } from 'motion/react'

const LazyMotionWrapper = ({ children }: { children: React.ReactNode }) => {
	return (
		<LazyMotion
			features={() =>
				import('lib/framer-motion/features').then((mod) => mod.default)
			}
		>
			{children}
		</LazyMotion>
	)
}

export default LazyMotionWrapper
